import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShareRedirectComponent } from './modules/share-redirect/share-redirect.component';
import { PasswordManagerComponent } from './modules/shared/password-manager/password-manager.component';
import { ActivePageComponent } from './modules/shared/active-page/active-page.component';
import { JobDetailsComponent } from './modules/job-details/job-details.component';
import { ApprovalComponent } from './modules/approval/approval.component';
import { RequirementApprovalComponent } from './modules/requirement-approval/requirement-approval.component';
import { IjpComponent } from './modules/ijp/ijp.component';
import { MyJobsComponent } from './modules/my-jobs/my-jobs.component';
import { SessionService } from './services/session/session.service';
import { SocialMediaRedirectComponent } from './modules/login-v2/social-media-redirect/social-media-redirect.component';


const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'redirect',
    component: SocialMediaRedirectComponent
  },
  {
    path: 'reg',
    loadChildren: () => import('./modules/jobseeker-registration/registration.module').then(m => m.RegistrationModule),
  },
  {
    path: 'registration',
    loadChildren: () => import('./modules/jobseeker-registration/registration.module').then(m => m.RegistrationModule),
  },
  {
    path: 'registration/ref/:id',
    loadChildren: () => import('./modules/jobseeker-registration/registration.module').then(m => m.RegistrationModule),
  },
  // {
  //   path: 'home',
  //   loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
  // },
  {
    path: 'edit-profile',
    loadChildren: () => import('./modules/jobseeker-registration/registration.module').then(m => m.RegistrationModule),
  },
  {
    path: 'resume-approval/:req_res_id/:user_id/:status',
    component: ApprovalComponent
  },
  {
    path: 'requirement-approval/:req_guid/:user_id/:status',
    component: RequirementApprovalComponent
  },
  {
    path: 'password-manager/:user_id',
    component: PasswordManagerComponent,
  },
  {
    path: 'link-exipred',
    component: ActivePageComponent
  },
  {
    path: 'jobs',
    component: IjpComponent,
  },
  {
    path: 'my-jobs',
    component: MyJobsComponent,
  },
  {
    path: 'job-details/:id',
    component: JobDetailsComponent
  },
  {
    path: 'job/:id',
    component: JobDetailsComponent
  },
  {
    path: 'my-journey',
    loadChildren: () => import('./modules/my-journey/my-journey.module').then(m => m.MyJourneyModule),
    canActivate: [SessionService]
  },
  {
    path: 'share-redirect',
    component: ShareRedirectComponent
  },
  {
    path: 'jobs/:id',
    component: IjpComponent
  },
  {
    path: '**',
    redirectTo: '/jobs'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
